/**
 * Google Analytics 配置
 */

// GA 测量 ID
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

// 检查 GA 是否已配置
export const isGAConfigured = Boolean(
  GA_MEASUREMENT_ID && 
  GA_MEASUREMENT_ID !== 'undefined' && 
  GA_MEASUREMENT_ID.startsWith('G-')
);

// GA 配置选项
export const GA_CONFIG = {
  // 页面标题追踪
  page_title: true,
  // 页面位置追踪
  page_location: true,
  // 自定义参数
  custom_map: {
    // 可以添加自定义维度映射
  },
  // 调试模式（仅开发环境）
  debug_mode: import.meta.env.DEV,
  // 匿名化 IP（GDPR 合规）
  anonymize_ip: true,
  // 禁用广告功能（可选）
  allow_ad_personalization_signals: false,
};

// 事件名称常量
export const GA_EVENTS = {
  // 页面浏览
  PAGE_VIEW: 'page_view',
  
  // 用户认证
  LOGIN: 'login',
  SIGN_UP: 'sign_up',
  LOGOUT: 'logout',
  
  // OAuth 相关
  OAUTH_LOGIN_ATTEMPT: 'oauth_login_attempt',
  OAUTH_LOGIN_SUCCESS: 'oauth_login_success',
  OAUTH_LOGIN_ERROR: 'oauth_login_error',
  
  // 订阅相关
  VIEW_PRICING: 'view_pricing',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  SUBSCRIPTION_CANCEL: 'subscription_cancel',
  
  // 功能使用
  VIEW_FEATURES: 'view_features',
  PROFILE_VIEW: 'profile_view',
  
  // 错误追踪
  ERROR_OCCURRED: 'error_occurred',
  
  // 自定义事件
  CUSTOM_EVENT: 'custom_event',
} as const;

// 事件参数类型
export interface GAEventParams {
  event_category?: string;
  event_label?: string;
  value?: number;
  currency?: string;
  method?: string;
  provider?: string;
  error_message?: string;
  page_title?: string;
  page_location?: string;
  [key: string]: any;
}

export default {
  GA_MEASUREMENT_ID,
  isGAConfigured,
  GA_CONFIG,
  GA_EVENTS,
};